import { render } from "./HeartOutline.vue?vue&type=template&id=2a97a268"
import script from "./HeartOutline.vue?vue&type=script&lang=js"
export * from "./HeartOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__